<template>
  <v-container>
    <v-row v-for="a in alerts" v-show="a.show" justify="center">
      <v-col cols="12" :md="md">
        <v-alert
          v-model="a.show"
          :type="a.type"
          :title="a.title"
          :text="a.msg"
          density="compact"
          closable
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';

let idxAlerts = 0;
const alerts = ref([]);

function successAlert(title, msg) {
  alerts.value.push({
    id: idxAlerts,
    type: 'success',
    title: title,
    msg: msg,
    show: true
  });
  idxAlerts++;
}

function errorAlert(title, msg) {
  alerts.value.push({
    id: idxAlerts,
    type: 'error',
    title: title,
    msg: msg,
    show: true
  });
  idxAlerts++;
}

function warningAlert(title, msg) {
  alerts.value.push({
    id: idxAlerts,
    type: 'warning',
    title: title,
    msg: msg,
    show: true
  });
  idxAlerts++;
}

defineExpose({
  successAlert,
  errorAlert,
  warningAlert
});

defineProps({
  md: {
    type: String,
    default: '6',
  }
});
</script>

<style scoped>

</style>
